/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-11T10:48:26.343
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentTenant,
	getRentTenantCreateInit,
	getRentTenantEditInit,
	getRentTenantView,
	deleteRentTenant
} from '@api/rentmanage/RentTenant';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getRentTenantCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentTenantCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentTenantEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTenantEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentTenant({}, RentTenant) {
			return new Promise((resolve, reject) => {
				saveRentTenant(RentTenant)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentTenantView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTenantView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentTenant({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentTenant({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
